import { useEffect, useState } from "react";

import styles from "./Index.module.scss";
export default function Indicator() {
  const [scroll, setScroll] = useState(100);

  useEffect(() => {
    const progressBarHandler = () => {
      const totalScroll = document.documentElement.scrollTop;
      const contentHeight =
        document.getElementById("post-content").scrollHeight;

      const windowHeight = contentHeight - 300;

      if (windowHeight > 2000) {
        // 4500 -> 2000
        const scroll = `${totalScroll / windowHeight}`;

        document.getElementById("indicator").classList.add("!block");
        setScroll(scroll);
      } else {
        document.getElementById("indicator").classList.remove("!block");
        setScroll(0);
      }
    };

    window.addEventListener("scroll", progressBarHandler);

    return () => window.removeEventListener("scroll", progressBarHandler);
  }, []);

  return (
    <div id="indicator" className={`${styles.indicator}`}>
      <div
        className={"h-1 origin-left scale-0 bg-bbc-brand-500 opacity-100"}
        style={{ transform: `scale(${scroll}, 1)` }}
      />
    </div>
  );
}
